import * as React from 'react';

import { PaywallDispatch } from '~teacher/components/PaywallDialog';
import { proCheck } from '~teacher/util/proCheck';

export function useAddFolderDialog(genericPaywallDispatch: PaywallDispatch) {
  const [isAddFolderDialogOpen, setAddFolderOpen] = React.useState(false);

  const openAddFolderDialog = () => {
    if (proCheck.canMakeFolders()) {
      setAddFolderOpen(true);
    } else {
      genericPaywallDispatch({ type: 'OPEN' });
    }
  };

  const closeAddFolderDialog = () => {
    setAddFolderOpen(false);
  };

  return {
    isAddFolderDialogOpen,
    openAddFolderDialog,
    closeAddFolderDialog,
  };
}
